import {Component, Input, OnInit} from '@angular/core';
import {RouteTrackerService} from '@mpt-fo/common/core/services/route-tracker.service';
import {Router} from '@angular/router';

@Component({
	selector: 'app-mobile-page-not-found',
	templateUrl: './mobile-page-not-found.component.html',
	styleUrls: ['./mobile-page-not-found.component.scss']
})
export class MobilePageNotFoundComponent implements OnInit {
	@Input() buttonName;
	@Input() route;

	constructor(private routeTracker: RouteTrackerService, private router: Router) {
	}

	ngOnInit(): void {

	}

	continue() {
		this.router.navigateByUrl(`${this.route}`);
	}

}
